//
// GENERATED by KVision
//
package pl.finn.forms.ezw

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager
import io.kvision.remote.registerKVisionServiceExceptions

expect class EzwService : IEzwService

object EzwServiceManager : KVServiceManager<EzwService>(EzwService::class) {
    init {
        registerKVisionServiceExceptions()
        bind(IEzwService::nowy, HttpMethod.POST, null)
        bind(IEzwService::edycja, HttpMethod.POST, null)
        bind(IEzwService::sprawdz, HttpMethod.POST, null)
        bind(IEzwService::zapisz, HttpMethod.POST, null)
        bind(IEzwService::podglad, HttpMethod.POST, null)
    }
}
